import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import { PerformanceFragmentDoc } from './perfomance';
import { RankFragmentDoc } from './rank';
import { ContactFragmentDoc } from './contact';
export type ProviderFragment = { __typename?: 'Provider', acceptSelfBilling: boolean, eligibleForSelfBilling: boolean, activeChangeRequestId?: string | null, allowAutoacceptOffers?: boolean | null, allowAutoacceptOffersFreezeUntil?: string | null, allowDirectshipOrders?: boolean | null, allowDirectshipOrdersFreezeUntil?: string | null, autoacceptPoNumberLimit?: number | null, autoacceptPoNumberLimitFreezeUntil?: string | null, autoacceptPoValueLimit?: number | null, autoacceptPoValueLimitFreezeUntil?: string | null, bankAccount?: string | null, bankAccountHolderName?: string | null, bankCode?: string | null, bankCountry?: string | null, bankName?: string | null, bdoNumber?: string | null, createdAt: string, datevKonto?: string | null, email?: string | null, financeCheckAt?: string | null, freeCapacity: boolean, freeCapacityFreezeUntil?: string | null, gstIn?: string | null, id: number, intacctId?: string | null, isEuropean?: boolean | null, lastVisitAt?: string | null, legalName?: string | null, limitsComment?: string | null, locale?: string | null, name?: string | null, notVatPayer: boolean, onImprovement: boolean, onImprovementComment?: string | null, onImprovementFreezeUntil?: string | null, onImprovementStartedAt?: string | null, partnerNetworkManagerFreezeUntil?: string | null, payoutTransferType?: string | null, phone?: string | null, pincode?: string | null, poNumberLimit?: number | null, poNumberLimitFreezeUntil?: string | null, poValueLimit?: number | null, poValueLimitFreezeUntil?: string | null, productionHoliday: boolean, publicComment?: string | null, primaryContactId?: number | null, publicHoliday: boolean, registeredAt?: string | null, salesforceId?: string | null, state: Types.ProviderStateEnum, testPartner: boolean, vatId?: string | null, vatValidationStatus?: Types.VatValidationStatusEnumType | null, vatValidationTimestamp?: string | null, website?: string | null, financeCheckBy?: { __typename?: 'User', id: number, name: string } | null, performance?: { __typename?: 'Performance', totalOrdersCount?: string | null, totalOrdersValue?: string | null, ordersInProductionCount?: string | null, ordersInProductionValue?: string | null, ordersBePaidCount?: string | null, ordersBePaidValue?: string | null, ordersPaidCount?: string | null, ordersPaidValue?: string | null, ordersInProductionMoney?: { __typename?: 'Money', amount: string, amountCents: string, currencyCode: Types.CurrencyEnum } | null } | null, rank?: { __typename?: 'Rank', total?: number | null, timing?: number | null, overdueRatio?: number | null, quality?: number | null, packing?: number | null, communication?: number | null, poQuantity?: number | null, qualityRatio?: number | null, cancelRatio?: number | null, delayedProviderOrdersQuantity?: number | null } | null, tags: Array<{ __typename?: 'Tag', approved: boolean, id: number, name: string, context: string }>, billingAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, zip?: string | null, address?: string | null } | null, shippingAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, region?: string | null, zip?: string | null, address?: string | null } | null, contacts: Array<{ __typename?: 'ProviderContact', id: number, firstName: string, lastName: string, email: string, position?: string | null, phone?: string | null, viber?: string | null, whatsapp?: string | null, telegram?: string | null, wechat?: string | null, preferredContactType?: string | null, disallowToPool?: boolean | null, verifiedAt?: string | null, verifyKey?: string | null }>, partnerNetworkManager?: { __typename?: 'User', id: number, name: string } | null, partnerSuccessManager?: { __typename?: 'User', id: number, name: string } | null };

export const ProviderFragmentDoc = gql`
    fragment provider on Provider {
  acceptSelfBilling
  eligibleForSelfBilling
  activeChangeRequestId
  allowAutoacceptOffers
  allowAutoacceptOffersFreezeUntil
  allowDirectshipOrders
  allowDirectshipOrdersFreezeUntil
  autoacceptPoNumberLimit
  autoacceptPoNumberLimitFreezeUntil
  autoacceptPoValueLimit
  autoacceptPoValueLimitFreezeUntil
  bankAccount
  bankAccountHolderName
  bankCode
  bankCountry
  bankName
  bdoNumber
  createdAt
  datevKonto
  email
  financeCheckAt
  freeCapacity
  freeCapacityFreezeUntil
  gstIn
  id
  intacctId
  isEuropean
  lastVisitAt
  legalName
  limitsComment
  locale
  name
  notVatPayer
  onImprovement
  onImprovementComment
  onImprovementFreezeUntil
  onImprovementStartedAt
  partnerNetworkManagerFreezeUntil
  payoutTransferType
  phone
  pincode
  poNumberLimit
  poNumberLimitFreezeUntil
  poValueLimit
  poValueLimitFreezeUntil
  productionHoliday
  publicComment
  primaryContactId
  publicHoliday
  registeredAt
  salesforceId
  state
  testPartner
  vatId
  vatValidationStatus
  vatValidationTimestamp
  website
  financeCheckBy {
    id
    name
  }
  performance {
    ...performance
  }
  rank {
    ...rank
  }
  tags {
    approved
    id
    name
    context
  }
  billingAddress {
    city
    country
    zip
    address
  }
  shippingAddress {
    city
    country
    region
    zip
    address
  }
  contacts {
    ...contact
  }
  partnerNetworkManager {
    id
    name
  }
  partnerSuccessManager {
    id
    name
  }
}
    ${PerformanceFragmentDoc}
${RankFragmentDoc}
${ContactFragmentDoc}`;